import React from "react"

import MobileTableSelection from "./mobile_table_selection"
import { type ReservationDetailsStepProps } from "./shared"

const ReservationDetailsStepMobile: React.FC<ReservationDetailsStepProps> = (props) => (
  <MobileTableSelection {...props} />
)

export default ReservationDetailsStepMobile
